import { defineMessages } from '@cookbook/solid-intl'

// Split out of `property-new-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    titleMessage: defineMessages({
        defaultMessage: 'Add New Listing | Lodgr',
        id: 'PropertyNewPage.titleMessage',
    }),
}
